var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SIZE_XL } from "../../helpers";
var Logo = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-shrink: 0;\n    display: block;\n    width: auto;\n    height: ", ";\n    min-height: ", ";\n    max-height: ", ";\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    background-color: transparent;\n    border: 0;\n    outline: none;\n    cursor: ", ";\n"], ["\n    flex-shrink: 0;\n    display: block;\n    width: auto;\n    height: ", ";\n    min-height: ", ";\n    max-height: ", ";\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    background-color: transparent;\n    border: 0;\n    outline: none;\n    cursor: ", ";\n"])), SIZE_XL, SIZE_XL, SIZE_XL, function (_a) {
    var onClick = _a.onClick;
    return (onClick ? 'pointer' : 'default');
});
export var AppBarLogo = function (_a) {
    var src = _a.src, rest = __rest(_a, ["src"]);
    return (React.createElement(Logo, __assign({}, rest, { src: src, "data-selector-id": rest['data-selector-id'] || 'appbar-logo' })));
};
var templateObject_1;
//# sourceMappingURL=AppBarLogo.js.map